export default "__VITE_ASSET__BPZNx_eP__"